<template>
  <a-card :title="formRecord.package_id > 0 ? '编辑素材包' : '创建素材包'">
    <a-form  :model="formRecord" style="margin: 10px auto;" >
      <a-form-item  required label="名称">
        <a-input  placeholder="名称" v-model:value="formRecord.name" />
      </a-form-item>
      <a-form-item required label="描述">
        <a-input placeholder="描述" v-model:value="formRecord.desc" />
      </a-form-item>
      <a-form-item label="工具ID">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formRecord.tool_id"
          :options="ToolIDOptions"
        />
      </a-form-item>
      <a-form-item label="模板ID">
        <a-input placeholder="模板ID" v-model:value="formRecord.template_id" />
      </a-form-item>
      <a-form-item required label="任务类型"  name="style_id">
        <a-select
          :allowClear="true"
          style="width: 180px;"
          v-model:value="formRecord.style_id"
          :options="TaskStyleGroupOptions"
        />
      </a-form-item>
       <a-form-item required label="素材类型"  name="resource_type">
        <a-select
          :disabled="formRecord.package_id > 0"
          :allowClear="true"
          style="width: 180px;"
          v-model:value="formRecord.resource_type"
          :options="resourceTypeOptions"
        />
      </a-form-item>
      <a-button v-if="formRecord.package_id > 0" type="primary" @click="handleSavePackageInfo">保存基础信息</a-button>
    </a-form>
    <div v-if="formRecord.resource_type == 'refer_image'" >
      <a-upload-dragger
        v-model:fileList="fileList"
        name="file"
        :multiple="true"
        accept="image/*"
        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        @change="handleUploadedChange"
        @drop="handleUploadedDrop"
        :customRequest="handleUpload"
        :beforeUpload="beforeUpload"
        :show-upload-list="false"
        list-type="picture"
      >
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <p class="ant-upload-text">Click or drag file to this area to upload</p>
        <p class="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibit from uploading company data or other
          band files
        </p>
      </a-upload-dragger>
      
      <a-table 
        class="ant-table-striped"
        :row-key="record => record.uid"
        :data-source="fileList" 
        :columns="columns" 
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #size="{ record }">
          {{ record.size ? (record.size / 1024).toFixed(2) + 'KB' : '' }}
        </template>
        <template #status="{ record }">
          <a-tag v-if="record.status =='error'" color='red'>{{ record.status }}{{ record.errmsg }}</a-tag>
            <a-tag v-else-if="record.status =='uploading'" color='blue'>{{ record.status }}</a-tag>
            <a-tag v-else color='green'>{{ record.status }}</a-tag>
        </template>
        <template #action="{ record }">
          <a-button danger @click="() => handleDelete(record)">删除</a-button>
        </template>
      </a-table>
      <div v-if="resourcesModified" style="margin: 10px;">
        已添加 {{ fileList.length }} 条素材
        已上传完成 {{ fileListUploaded.length }} 条
        <a-tag color="green" v-if="fileListUploaded.length == fileList.length">上传成功</a-tag>
        <a-tag color="red" v-else >未全部上传成功，注意是否符合预期</a-tag>
      </div>
    </div>
    <div v-if="formRecord.resource_type == 'prompt'">
      <a-table 
        class="ant-table-striped"
        :row-key="record => record.id"
        :data-source="fileList" 
        :pagination="false"
        :columns="promptColumns" 
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #operator_id="{ record }">
          <Username :user_id="record.operator_id" />
        </template>
        <template #content="{ record }">
          <a-textarea v-model:value="record.content" />
        </template>
        <template #name="{ record }">
          <a-input v-model:value="record.name" />
        </template>
         <template #action="{ record }">
          <a-button danger @click="() => handleDelete(record)">删除</a-button>
        </template>
      </a-table>
      <div style="margin: 10px; text-align: right;">
        <a-button v-if="formRecord.resource_type == 'prompt'" type="primary" @click="handelAddPrompt">+增加一条</a-button>
      </div>
    </div>
     
    <div style="margin-top:20px;">
      <a-button v-if="formRecord.package_id > 0" type="primary" @click="handleSavePackages">保存素材信息</a-button>
      <a-button v-else :disabled="!this.fileList.length" type="primary" @click="handleSavePackages">创建素材包</a-button>
    </div>
  </a-card>

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import request from '@/utils/request'
import { useStore } from 'vuex'
import {useRoute} from 'vue-router'
import { TaskStyleGroupOptions, SubTypeOptions ,StyleNames, ToolIDOptions} from '@/utils/macro'
import OSS from 'ali-oss'

export default defineComponent({
  components: {
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      fileList: [],
      ToolIDOptions,
      StyleNames,
      TaskStyleGroupOptions,
      resourceTypeOptions: [
        {
          label: "Prompt", value: 'prompt'
        }, {
          label: "ReferImage", value: 'refer_image'
        },
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',
      formRecord: {
        desc: '',
        resource_type: 'refer_image',
        tool_id: '',
        template_id: '',
        style_id: '',
        name: '',
      },
      resourcesModified:  false,
      uploadLoading: false,
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['package_id']) {
      this.formRecord.package_id = route.query['package_id']
    }
    if ( this.formRecord.package_id > 0) {
      this.getPackage()
    }

    // this.handleTableChange()
  },
  computed:{
    fileListUploaded(){
      return this.fileList.filter((i) => i.status == 'done')
    }
  },
  methods: {
    handelAddPrompt(){
      this.fileList.push({
        name: '',
        content: '',
        resource_type: 'prompt',
      })
    },
    handleDelete(item){
      this.fileList = this.fileList.filter((i) => i.uid !== item.uid)
      this.resourcesModified = true

    },
    getPackage(){
      request.get(`/api/testcase/packages/${this.formRecord.package_id}`).then((resp) => {
        if (resp.error) {
          message.error(`获取失败:` + resp.error.message)
          return 
        }
        this.formRecord = resp.data
        this.formRecord.package_id = resp.data.id
      })
      request.get(`/api/testcase/packages/${this.formRecord.package_id}/resources`).then((resp) => {
        if (resp.error) {
          message.error(`获取失败:` + resp.error.message)
          return 
        }
        let result = resp.data.list
        this.fileList = []
        for (let item of result) {
          item.status = 'done'
          item.uid = `${item.id}`
          this.fileList.push(item)
        }
      })


    },
    async handleSavePackageInfo(){
      if (this.formRecord.package_id <= 0) {
        message.error(`请先创建或选择一个素材包`)
        return 
      }
      let params = {
        ...this.formRecord,
        template_id: `${this.formRecord.template_id}`,
        // resources: resources,
      }
      const resp = await request.put(`/api/testcase/packages/${this.formRecord.package_id}`, params)
      if (resp.error) {
        message.error(`保存失败:` + resp.error.message)
        return 
      }
    
    },
    async handleSavePackages(){
      if (this.fileList.length === 0) {
        message.error("请上传素材")
        return 
      }

      let params = {
        ...this.formRecord,
        template_id: `${this.formRecord.template_id}`,
        // resources: resources,
      }
      let resources = []
      for (let item of this.fileList) {
        // item.name 是文件名，取文件名作为资源名称
        if (this.formRecord.resource_type === 'prompt') {
          if (!item.content || !item.name) {
            message.error("请输入Prompt内容和名称")
            return 
          }
          resources.push({
            name: item.name.split('.')[0],
            content: item.content,
          })
        } else if (this.formRecord.resource_type === 'refer_image') {
          console.log("item", item)
          if (item.status !== 'done') {
            continue
          }
          resources.push({
            name: item.name.split('.')[0],
            image_key: item.image_key,
            size: item.size,
          })
        }
      }
      if (resources.length === 0) {
        message.error("没有有效的素材提供，看看图片是不是上传失败了？")
        return 
      }
      params['resources'] = resources
      let package_id = 0
      if (this.formRecord.package_id > 0) {
        const resp = await request.put(`/api/testcase/packages/${this.formRecord.package_id}`, params)
        if (resp.error) {
          message.error(`保存失败:` + resp.error.message)
          return 
        }
      } else {
        const resp = await request.post(`/api/testcase/packages/`, params)
        if (resp.error) {
          message.error(`保存失败:` + resp.error.message)
          return 
        }
        // 弹出蒙层提示可以继续编辑
        Modal.info({
          title: '保存成功',
          content: '当前素材包创建成功，可以继续在当前页面编辑',
        })
        this.formRecord.package_id = resp.data.package_id
      }
    
      message.success("保存成功")
      this.getPackage()
      // this.$router.push({path: '/home/testcase/packages/resources', query: {package_id: package_id}})

    },
    async handleUpload(handle) {
      if (!handle.file) {
          message.error("请选择文件")
          return 
      }
      handle.onSuccess = (res) => {
        handle.file.status = 'done'
      }
      console.log('handleUpload.file', handle)

      // /api/aliyun/sts
      const sts = await request.post(`/api/aliyun/sts?image_type=testcase`, {}, "")
      if (sts.error) {
        message.error(`存储服务授权失败:` + sts.error.message)
        return 
      }
      const client =  new OSS({
          accessKeyId: sts.data.sts_cert.AccessKeyId,
          accessKeySecret: sts.data.sts_cert.AccessKeySecret,
          stsToken: sts.data.sts_cert.SecurityToken,
          bucket: 'xuantupro',
          region: 'oss-cn-shanghai'
      });
      const name = `/${sts.data.bucket_path}/${sts.data.filename}.${handle.file.type.split('/')[1]}`
      const result = await client.multipartUpload(name, handle.file);
      var url = "http://statica.xuantu.pro" // 待定
      if (result && result.name) {
          url = url + result.name
      }
      // handle.file.url = url
      // handle.file.status = 'done'
      for (let idx in this.fileList) {
        if (this.fileList[idx].uid === handle.file.uid) {
          this.fileList[idx].url = url
          // name 的第一个 / 移除
          this.fileList[idx].image_key = name.substring(1)
          this.fileList[idx].status = 'done'
        }
      }
      this.resourcesModified = true
      return 
    },
    beforeUpload(file,filelist) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
      const isLt2M = file.size < 1024 * 1024;
      if (isJpgOrPng && !isLt2M) {
        message.error('图片需要小于 1MB');
        for(let item of filelist) {
          if (item.uid === file.uid) {
            item.status = 'error'
            item.errmsg = '图片需要小于 1MB'
          }
        }
        return false
      }
 
      return true;
    },
    handleUploadedDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    handleUploadedChange(info) {
      console.log('handleUploadedChange')
      const status = info.file.status;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      if (!this.formRecord.package_id) {
        return
      }
      this.loading = true
     
      let limit = pagi.pageSize
      let orderBy = "id desc"
      let offset =  (pagi.current - 1) * pagi.pageSize
      const rsp = await request.get(`/api/testcase/packages/${this.formRecord.package_id}/resources`, {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        ...this.formRecord,
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      
      for(let item of this.dataSource) {
        item.created_at = new Date(item.created_at).toLocaleString()
        item.updated_at = new Date(item.updated_at).toLocaleString()
      }
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`

      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
    return {
      uploadInput: null,
      promptColumns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width:80,
        },
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          width:200,
          slots: { customRender: 'name' },
        },
         {
          title: 'Prompt',
          dataIndex: 'prompt',
          key: 'prompt',
          slots: { customRender: 'content' },
        },
         {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator_id' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width:80,
        },
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          width:200,
        },
         {
          title: '大小',
          dataIndex: 'size',
          key: 'size',
          slots: { customRender: 'size' },
        },
         {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
.thumbnail-item {
  display: inline-block;
  /* flex-direction: row; */
  width: 180px;
  margin: 2px;
}
</style>